export default __webpack_public_path__ + "static/media/Front.0e10ca23.png";